export const removePx = (value: string | null | undefined) => {
  if (!value) return 0

  return Number(value.replace('px', ''))
}
